/* globals angular, _ */
(function() {
  'use strict';

  function IntegrationModalCtrl (
    $mdDialog,
    IntegrationResource,
    provider,
    localStorageService
  ) {
    var ctrl = this;
    ctrl.provider = provider;
    ctrl.close = function () {
      $mdDialog.cancel();
    };
    ctrl.hideErrorMsg = function () {
      ctrl.showErrorMsg = false;
    };
    ctrl.formSubmit = function (form) {

      if (form.$invalid) { return; }
      var settings = {};
      _.forEach(ctrl.provider.fields, function (field) {
        settings[field.key] = form[field.key].$modelValue;
      });
      ctrl.isLoading = true;
      ctrl.showErrorMsg = false;
      IntegrationResource
        .authorize({ provider: provider.slug }, settings)
        .$promise
        .then(function(response){
          $mdDialog.hide({ slug: provider.slug, data: response });
        })
        .catch(function(){
          ctrl.showErrorMsg = true;
          ctrl.isLoading = false;
        });
    };
  }

  angular
    .module('mandaeApp')
    .controller('IntegrationModalCtrl', IntegrationModalCtrl);
}());
